/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_PrivacyInputs */

const en_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const ko_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보처리방침`)
};

const ja_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_PrivacyInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const footer_privacy = /** @type {((inputs?: Footer_PrivacyInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_PrivacyInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_privacy(inputs)
	if (locale === "ko") return ko_footer_privacy(inputs)
	return ja_footer_privacy(inputs)
});